import { invert } from 'lodash-es';
import { BROWSER_TYPE } from '../../../components/StatelessComponent/SingleFilter/BrowserFilter/BrowserFilterType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import { QueryKeyEnum } from '../../../domains/global-filters/model/QueryFormat';
import * as ShortStringListConverter from './GenericConverter/ShortStringListConverter';

const queryValueByUiValue: Record<BROWSER_TYPE, string> = {
  [BROWSER_TYPE.CHROME]: 'Chrome',
  [BROWSER_TYPE.CHROMIUM]: 'Chromium',
  [BROWSER_TYPE.SAFARI]: 'Safari',
  [BROWSER_TYPE.FIREFOX]: 'Firefox',
  [BROWSER_TYPE.IE]: 'IE',
  [BROWSER_TYPE.EDGE]: 'Edge',
  [BROWSER_TYPE.OPERA]: 'Opera',
};

const uiValueByQueryValue = invert(queryValueByUiValue) as Record<string, BROWSER_TYPE>;

export function fromUiToQueryFormat(uiValue?: BROWSER_TYPE[]): QueryFormatFilter {
  if (!uiValue) {
    throw new Error(`uiValue is undefined`);
  }
  return ShortStringListConverter.fromUiToQueryFormat(
    uiValue,
    QueryKeyEnum.browser,
    queryValueByUiValue,
  );
}

export function fromIntermediateToUiFormat(intermediateValue: IntermediateFormat): BROWSER_TYPE[] {
  return ShortStringListConverter.fromIntermediateToUiFormat(
    intermediateValue,
    uiValueByQueryValue,
  );
}
